import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
type CtaButtonProps = {
  label: string;
  id?: string;
  size?: 'lg' | 'md';
  shake?: boolean;
  className?: string;
};
export function CtaButton({
  label,
  id,
  size = 'lg',
  shake = false,
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'min-h-[68px] px-5 py-4 text-[22px] sm:text-[26px]' : 'min-h-[58px] px-4 py-3 text-[19px] sm:text-[22px]';
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-2xl bg-amber text-center font-display font-extrabold uppercase leading-[1.05] tracking-wide text-ink shadow-[0_6px_0_#B88600,0_14px_30px_-8px_rgba(255,194,26,0.55)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-amber-light active:translate-y-[4px] active:shadow-[0_2px_0_#B88600] focus:outline-none focus-visible:ring-4 focus-visible:ring-volt/60 ${sizing} ${shake ? 'cta-shake' : ''} ${className}`} data-id="element-27" data-mp="llqv76kplu22">
      <span className="text-balance" data-id="element-28" data-mp="35z8sifjhfdf4">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={3} aria-hidden="true" data-id="element-29" data-mp="39zsrzprj2t4f" />
    </a>;
}